<template>
    <div class="schoolLevel">
        <a-form-model layout="inline" style="display: flex;justify-content: space-around;">
            <a-form-model-item label="选择机构">
                <many-select v-model="organizationId" showSearch allowClear optionFilterProp="name" :disabled="IsDetails"
                            :options="organizationList"
                            :replaceFields="{label: 'name', value: 'id'}"
                          @change="selectChange" placeholder="请选择机构" style="width:250px;">
                </many-select>
            </a-form-model-item>
            <a-form-model-item label="学生一致">
                <a-switch v-model="uniformity.schoolUniformity" :disabled="IsDetails"
                          :loading="switchLoading"
                          @change="switchChange"
                          checked-children="启用" un-checked-children="禁用"/>
            </a-form-model-item>
            <a-form-model-item v-if="tableRelevant.tableDataSource.length">
                <a-dropdown :trigger="['click']" v-model="dropdownVisible" :disabled="IsDetails">
                    <a-button @click="e => e.preventDefault()">快速配置学生</a-button>
                    <a-menu slot="overlay">
                            <a-menu-item key="0" @change="change0" >
                                <a-checkbox value="0" v-model="checkboxs.a">未开始</a-checkbox>
                            </a-menu-item>
                            <a-menu-item key="1" @change="change0" >
                                <a-checkbox value="1" v-model="checkboxs.b">进行中</a-checkbox>
                            </a-menu-item>
                            <a-menu-item key="2" @change="change0" >
                                <a-checkbox value="2" v-model="checkboxs.c">已完成</a-checkbox>
                            </a-menu-item>
                        <a-menu-divider />
                        <a-menu-item>
                            <a-button style="margin-right:15px;" @click="quickSetClose()">取消</a-button>
                            <a-button type="primary" @click="quickSet()" :disabled="quickSetStudent.length < 1">确定</a-button>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </a-form-model-item>
            <a-form-model-item v-if="tableRelevant.tableDataSource.length">
                <a-button @click="resetComputed()" :disabled="IsDetails">重新算分</a-button>
            </a-form-model-item>
            <a-form-model-item v-if="organizationId && !IsDetails">
                <a-button @click="addRound" type="primary">添加测评</a-button>
            </a-form-model-item>
        </a-form-model>
        <div style="margin: 30px auto;width: 95%;">
            <StepsSecondCourse :tableLoading="tableRelevant.tableLoading"
                               @loading="bool => tableRelevant.tableLoading = bool"
                               @renewData="getGroupReportCourseInfo"
                               :uniformity="uniformity"
                               :IsDetails="IsDetails"
                               :tableDataSource="tableRelevant.tableDataSource"/>
        </div>
        <!-- 添加测评 -->
        <a-modal v-model="course.visible" title="添加测评" width="70%" @ok="courseSubmit"
                 :confirm-loading="course.confirmLoading" :destroyOnClose="true">
            <StepsSecondAddCourse :key="course.key" :select-data="selectTableData" ref="addCourse"
                                  :organizationId="organizationId"/>
        </a-modal>

    </div>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";
    import StepsSecondAddCourse from "@/pages/reportCenter/groupReport/components/StepsSecondAddCourse";
    import StepsSecondCourse from "@/pages/reportCenter/groupReport/components/StepsSecondCourse";
    import ManySelect from "@/components/select/ManySelect";

    export default {
        name: 'SchoolLevelSet',
        props: {
            IsDetails: {
                type: Boolean,
                default: false
            }
        },
        components: {StepsSecondAddCourse, StepsSecondCourse, ManySelect},
        data() {
            return {
                organizationId: this.$store.getters["organization/getReportInfo"].organizationId || undefined,
                // organizationId: 290271483965509,
                organizationList: [],
                uniformity: {
                    schoolUniformity: this.$store.getters["organization/getReportInfo"].studentSampleTakingMethod === 2,
                    sampleInsideUniformity: undefined,
                    sampleOutsideUniformity: undefined,
                },
                columns: [
                    {title: '测评名称', dataIndex: 'projectCourseConfigName'},
                    {title: '资源名称', dataIndex: 'courseName'},
                    {title: '课时名称', dataIndex: 'childCourseName'},
                    {title: '学生数', scopedSlots: {customRender: 'student'}},
                    {title: '操作', scopedSlots: {customRender: 'action'}},
                ],
                tableRelevant: tableRelevant.call(this),
                switchLoading: false,
                selectTableData: [],
                course: {
                    key: Date.now(),
                    visible: false,
                    confirmLoading: false,
                },
                dropdownVisible:false,
                quickSetStudent:[],
                checkboxs:{
                    a:false,
                    b:false,
                    c:false,
                }
            }
        },
        mounted() {
            this.getOrganizationList();
            this.getGroupReportCourseInfo();
        },
        watch:{
            dropdownVisible(val){
                if(!val){
                    this.quickSetStudent = []
                    this.checkboxs = {
                        a:false,
                        b:false,
                        c:false,
                    }
                }
            }
        },
        computed: {
            rowSelection() {
                return {
                    selectedRowKeys: this.course.selectedRowKeys,
                    onChange: (selectedRowKeys, selectedRows) => {
                        this.course.selectedRowKeys = selectedRowKeys;
                    }
                };
            }
        },
        methods: {
            change0(e){
                if(e.target.checked){
                    this.quickSetStudent.push(+e.target._value)
                }else{
                    this.quickSetStudent = this.quickSetStudent.filter(f => f != e.target._value)
                }
            },
            quickSetClose(){
                this.dropdownVisible = false
                this.quickSetStudent = []
                this.checkboxs = {
                    a:false,
                    b:false,
                    c:false,
                }
            },
            // 快速配置学生
            quickSet(){
                let params = {
                    groupReportId: this.$store.getters["organization/getReportInfo"].id,
                    completionStatus:this.quickSetStudent
                }
                this.$http.GroupReport.BatchStudentSetting(params)
                .then(res =>{
                    this.$message.destroy();
                    this.$message.success(res.message);
                    this.getGroupReportCourseInfo();
                    this.dropdownVisible = false
                    this.quickSetStudent = []
                    this.checkboxs = {
                        a:false,
                        b:false,
                        c:false,
                    }
                })
            },
            // 重新算分
            resetComputed(){
                let that = this
                this.$confirm({
                    title: '确认重新算分?',
                    content: '重新算分后原有分数将被清空，请确认此操作',
                    onOk() {
                        let formData = new FormData();
                        that.tableRelevant.tableDataSource.forEach(v =>{
                            formData.append('customerChildCourseIds', v.projectCourseChildId)
                            formData.append('customerCourseIds', v.projectCourseConfigId)
                        })
                        that.$http.GroupReport.GroupReportUpdateCourseContentScore(formData)
                        .then(res =>{
                            that.$message.destroy();
                            that.$message.success(res.message);
                        })
                    },
                    onCancel() {},
                });
            },
            switchChange(checked) {
                const reportInfo = this.$store.getters["organization/getReportInfo"];
                const Params = {
                    groupReportId: reportInfo.id,
                    studentSampleTakingMethod: checked ? 2 : 0
                };
                this.switchLoading = true;
                this.$http.GroupReport.updateStudentSampleTakingMethod(Params).then(res => {
                    this.$message.success(res.message);
                    this.getGroupReportCourseInfo();
                    this.$store.commit("organization/setReportInfo", {
                        ...reportInfo,
                        studentSampleTakingMethod: Params.studentSampleTakingMethod
                    });
                });
            },
            addRound() {
                console.log(this.selectTableData);
                this.course.visible = true;
                this.course.key = Date.now();
            },
            selectChange() {
                if (!this.tableRelevant.tableDataSource.length) {
                    return
                }
                const form = new FormData();
                form.append("GroupReportId", this.$store.getters["organization/getReportInfo"].id);
                form.append("OrganizationId", this.tableRelevant.tableDataSource[0].organizationId);
                this.$http.GroupReport.deleteOrgGroupReportCourse(form).then(res => {
                    this.selectTableData = []
                    this.tableRelevant.tableDataSource = [];
                })
            },
            // 添加测评
            courseSubmit() {
                this.$message.destroy();
                if (!this.$refs.addCourse.selectedRowKeys.length) {
                    this.$message.warning('请选择测评');
                    return
                }
                const RequestBody = this.$refs.addCourse.selectedRowKeys.map(m => {
                    let split = m.split(",");
                    return {
                        groupReportId: this.$store.getters["organization/getReportInfo"].id,
                        //groupReportSampleId: ,
                        organizationId: this.organizationId,
                        projectCourseConfigId: +split[1],
                        projectCourseChildId: +split[0],
                    }
                });
                this.course.confirmLoading = true;
                this.$http.GroupReport.addCourseChild(RequestBody).then(res => {
                    this.course.visible = false;
                    this.$message.success(res.message);
                    this.getGroupReportCourseInfo();
                }).finally(() => {
                  this.course.confirmLoading = false;
                })
            },

            // 获取团体报告配置课程信息
            getGroupReportCourseInfo() {
                this.selectTableData = [];
                const Params = {
                    groupReportId: this.$store.getters["organization/getReportInfo"].id
                };
                this.tableRelevant.tableLoading = true;
                this.$http.GroupReport.getGroupReportCourseInfo(Params).then(res => {
                    if (res.data[0]) {
                        this.tableRelevant.tableDataSource = res.data[0].items;
                        this.selectTableData = res.data[0].items.map(m => m.projectCourseChildId);
                        if (res.data[0].items[0]) {
                            this.organizationId = res.data[0].items[0].organizationId
                        }
                    } else {
                        this.tableRelevant.tableDataSource = []
                    }
                }).finally(() => {
                  this.tableRelevant.tableLoading = false;
                  this.switchLoading = false;
                })
            },
            // 获取机构列表
            getOrganizationList() {
                this.$http.loadAllByType({isOnlySuperior: false,orgType:1}).then(res => {
                    this.organizationList = res.data.data;
                });
            }
        }
    }
</script>

<style scoped>

</style>
